module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"createSchedule":"ჩანიშვნა","cancel":"გაუქმება","createCase":"ქეისის შექმნა","telemedicine":"ონლაინ","visit":"კლინიკაში","house_call":"გამოძახება","attachCase":"ქეისზე მიმაგრება","interviewInited":"კითხვარი არ არის შევსებული","interviewActive":"კითხვარი დაუსრულებელია","interviewFinished":"კითხვარი დასრულებულია","interviewCancelled":"კითხვარი გაუქმებულია"}}')
  delete Component.options._Ctor
}
